import React from 'react';
import { IconProps } from './types';

export const ScanAreaIcon: React.FC<IconProps> = ({
  size = 24,
  strokeWidth = 2,
  primaryColor = 'currentColor',
  className,
  title,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={primaryColor}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    role="img"
    aria-label={title}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M4 7v-1a2 2 0 0 1 2 -2h2" />
    <path d="M4 17v1a2 2 0 0 0 2 2h2" />
    <path d="M16 4h2a2 2 0 0 1 2 2v1" />
    <path d="M16 20h2a2 2 0 0 0 2 -2v-1" />
    <path d="M5 12l14 0" />
    <path d="M7 9l-2 3l2 3" />
    <path d="M17 9l2 3l-2 3" />
  </svg>
);
